import React, { useState } from "react";
import EsewaForm from "./EsewaForm";

function PaymentPage() {
  const [showEsewaForm, setShowEsewaForm] = useState(false);
  const [bookingData, setBookingData] = useState(null);


  const handleButtonClick = () => {
    setShowEsewaForm(true);
  };

  return (
    <div>
      <h1>Payment Page</h1>
      <button onClick={handleButtonClick}>Pay with Esewa</button>
      {showEsewaForm && (
        <EsewaForm
          amt={bookingData.amt}
          pid={bookingData.pid}
          tAmt={bookingData.tAmt}
          su={bookingData.su}
          fu={bookingData.fu}
        />
      )}
    </div>
  );
}

export default PaymentPage;
